import React, {
    ReactElement, useState,
} from "react";
import { Filters } from "../../../../components/filters/Filters";
import Loading from "../../../../components/loading/Loading";
import { useGetWorkflowServicesQuery, WorkflowService } from "../../../../__generated__/api";
import { NoDataOrError } from "../../../error/Error";
import ServiceCardSection from "./ServiceCardSection";

const INSTALLED_CATEGORY = "installed";
const NOT_INSTALLED_CATEGORY = "not-installed";
const CATEGORIES = [
    {
        value: INSTALLED_CATEGORY,
        label: "Installed",
    },
    {
        value: NOT_INSTALLED_CATEGORY,
        label: "Available",
    },
];

export default function WorkflowServices(): ReactElement {
    const { data: services, loading: isLoading, error } = useGetWorkflowServicesQuery();

    const [filterCategory, setFilterCategory] = useState(new Set<string>());
    const [search, setSearch] = useState("");

    if (isLoading) {
        return <Loading />;
    }
    if (error || !services?.workflowServices) {
        return <NoDataOrError error={error} />;
    }
    let serviceList = services.workflowServices;
    if (search) {
        const searchQuery = search.toLowerCase();
        serviceList = serviceList.filter(service => service.name.toLowerCase().includes(searchQuery)
                    || service.shortDescription?.toLowerCase().includes(searchQuery));
    }

    let installedServices: typeof serviceList = [];
    let notInstalledServices: typeof serviceList = [];

    const isNeither = !filterCategory?.has(INSTALLED_CATEGORY) && !filterCategory?.has(NOT_INSTALLED_CATEGORY);

    if (filterCategory?.has(INSTALLED_CATEGORY) || isNeither) {
        installedServices = serviceList.filter(service => service.installedIntegrationIds.isNotEmpty);
    }
    if (filterCategory?.has(NOT_INSTALLED_CATEGORY) || isNeither) {
        notInstalledServices = serviceList.filter(service => !service.installedIntegrationIds.isNotEmpty);
    }
    return (
        <form className="flex-grow-1">
            <div className="border p-3 rounded mb-5 bg-white">
                <Filters
                    onSetSearch={setSearch}
                    search={search}
                    onSelected={data => setFilterCategory(data)}
                    selectedCategories={filterCategory}
                    categories={CATEGORIES}
                    className="mb-3"
                    inputClassName="fs-4 fw-normal p-1 bottom-line-focus"
                />
                {installedServices.length > 0
                    && <ServiceCardSection direction="row" services={installedServices as WorkflowService[]} title="Installed" />}
                {notInstalledServices.length > 0
                    && (
                        <ServiceCardSection
                            direction="column"
                            services={notInstalledServices as WorkflowService[]}
                            title="Available"
                        />
                    )}
            </div>
        </form>
    );
}
